export const disableDiscountSelectButton = (pricing) => {
  return pricing.supplementaryCover && pricing.isLinkedToStageProduct;
};
